import React from 'react';
import PropTypes from 'prop-types';
import { PrintSize } from '../prop-types';
import { PrintSizeButton } from './print-size-button';

export default function ResizeOptionsModal({
  viewingSizeKey,
  showResizeOptionsModal,
  handleResizeOptionsModal,
  onClick,
  title,
  recommendedPrintSize,
  sizesWithPrints,
  sizesWithBadges,
}) {
  const printSizeList = [...sizesWithBadges]
    .filter(({ key }) => key !== viewingSizeKey)
    .sort(
      (a, b) =>
        (recommendedPrintSize && b.key === recommendedPrintSize.key) -
        (recommendedPrintSize && a.key === recommendedPrintSize.key),
    );

  return (
    <div
      role="dialog"
      className={`modal ${showResizeOptionsModal ? 'd-block show' : 'd-none'}`}>
      <div className="modal-dialog modal-sm size-options__modal">
        <div className="modal-content">
          <div className="modal-heading text-center">
            <h4 className="modal-title mb-3">{title}</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleResizeOptionsModal}
            />
          </div>
          <div className="modal-body">
            {printSizeList.map((size) => {
              const { badgeType, ...sizeProps } = size;

              return (
                <PrintSizeButton
                  key={size.key}
                  printSizeKey={size.key}
                  {...sizeProps}
                  onClick={onClick}
                  sizesWithPrints={sizesWithPrints}
                  badgeType={badgeType}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

ResizeOptionsModal.propTypes = {
  sizesWithBadges: PropTypes.arrayOf(PrintSize).isRequired,
  sizesWithPrints: PropTypes.arrayOf(PrintSize),
  viewingSizeKey: PropTypes.string,
  showResizeOptionsModal: PropTypes.bool.isRequired,
  handleResizeOptionsModal: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  recommendedPrintSize: PrintSize,
};

ResizeOptionsModal.defaultProps = {
  viewingSizeKey: undefined,
};
